import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useRBACStore } from '../stores/useRBACStore';

export function RBACRoute({
  roles,
  privileges,
  privilegeMode = 'any',
  children,
}) {
  // Enforce that only one of roles or privileges can be provided
  if (roles?.length && privileges?.length) {
    throw new Error(
      'RBACRoute: You should provide either roles or privileges, not both.'
    );
  }

  const hasAnyRole = useRBACStore((s) => s.hasAnyRole);
  const hasAnyPrivilege = useRBACStore((s) => s.hasAnyPrivilege);
  const hasAllPrivileges = useRBACStore((s) => s.hasAllPrivileges);

  let isAllowed = false;

  if (roles?.length) {
    isAllowed = hasAnyRole(roles);
  } else if (privileges?.length) {
    isAllowed =
      privilegeMode === 'all'
        ? hasAllPrivileges(privileges)
        : hasAnyPrivilege(privileges);
  }

  return isAllowed ? children : <Navigate to="/unauthorized" replace />;
}

RBACRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  privileges: PropTypes.arrayOf(PropTypes.string),
  privilegeMode: PropTypes.oneOf(['any', 'all']),
  children: PropTypes.node.isRequired,
};
